export default __webpack_public_path__ + "static/media/Trust 2.f1cdf540.pdf";